/* eslint-disable @typescript-eslint/no-explicit-any */
export const analyticsIdentifyUserIfNeeded = ({
	isAuthenticated,
	userId,
	userData,
}: {
	isAuthenticated?: boolean;
	userId?: string | null;
	userData: Record<any, any>;
}) => {
	// Check if the code is running in a browser environment
	if (typeof window !== "undefined") {
		// Check if the user is authenticated
		if (isAuthenticated && userId) {
			// Check if getUserId function is defined
			if (
				typeof window.rudderanalytics !== "undefined" &&
				typeof window.rudderanalytics.getUserId === "function"
			) {
				const data = {
					...userData,
					current_url: window.location.href,
					current_url_query_params: window.location.search,
					current_path: window.location.pathname,
				};

				// Check if the analytics userId is not same as the userId from the session, if yes identify the user
				if (window.rudderanalytics.getUserId() !== userId) {
					window.rudderanalytics.identify(userId, data);
				}
			}
		}
	}
};
